import { TS_Coupon }            from '../TravelSeller/Models/TS_Coupon';
import { BookingItemInterface } from './BookingItemInterface';

export class Coupon extends TS_Coupon implements BookingItemInterface {
    
}